import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { SplashScreenBlockConfig } from '@front-platform/content-builder';
import { splashScreenBlockResolveConfig } from '@front-platform/content-builder';
import { Component, input } from '@angular/core';

import {
  IContentBuilderFieldColor,
  IContentBuilderFieldImage,
} from '@core/models/content-builder-fields.model';
export interface SplashScreenBlockRuntimeConfig {}

export type SplashScreenBlockConfigInput = Partial<
  Omit<SplashScreenBlockConfig, keyof SplashScreenBlockRuntimeConfig> &
    SplashScreenBlockRuntimeConfig
>;
export type SplashScreenBlockResolvedConfig = Omit<
  SplashScreenBlockConfig,
  keyof SplashScreenBlockRuntimeConfig
> &
  Partial<SplashScreenBlockRuntimeConfig>;
export interface SplashScreenBlockContract extends ConfigComponentContract<
  SplashScreenBlockConfigInput,
  SplashScreenBlockResolvedConfig
> {}

@Component({
  selector: 'app-splash-screen-block',
  templateUrl: './splash-screen-block.component.html',
  standalone: false,
})
export class SplashScreenBlockComponent implements SplashScreenBlockContract {
  readonly config = input<SplashScreenBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    SplashScreenBlockConfig,
    SplashScreenBlockRuntimeConfig
  >(splashScreenBlockResolveConfig, () => ({ config: this.config() }));
  get image(): IContentBuilderFieldImage | undefined {
    return this.resolvedConfig()['image'] as unknown as IContentBuilderFieldImage | undefined;
  }
  get isOverlay(): boolean {
    return this.resolvedConfig()['is_overlay'] as unknown as boolean;
  }
  get linkUrl(): string | undefined {
    return this.resolvedConfig()['link_url'] as unknown as string | undefined;
  }
  get backgroundColor(): IContentBuilderFieldColor | undefined {
    return this.resolvedConfig()['background_color'] as unknown as
      IContentBuilderFieldColor | undefined;
  }

  isSplashScreenHidden = false;
  constructor() {}

  validateSplashScreen(): void {
    if (!this.linkUrl) {
      this.isSplashScreenHidden = true;
    }
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(SplashScreenBlockComponent, { 'keyAliases': {} });
